import Precision from "../../../../types/datePrecision";
import { isGregorianCalendarFromCalendar } from "../gregorianCalendar";
import dateWithTimestamp from "./dateWithTimestamp";

export const iso8601StringFromTimestamp = (calendar, inDate) => {
  let date = dateWithTimestamp(calendar, inDate.timestamp, inDate.precision);
  let iso8601String = "";

  // ISO8601 cannot handle non-Gregorian calendars
  if (!isGregorianCalendarFromCalendar(calendar)) {
    return "";
  }

  // Check for BC
  let yearString = "";
  if (date.era === 0) {
    const bcYear = date.year - 1;
    yearString = `${bcYear > 0 ? "-" : ""}${padWithZeros(bcYear, 4)}`;
  } else {
    yearString = `${padWithZeros(date.year, 4)}`;
  }

  switch (date.precision) {
    case Precision.Century:
    case Precision.Decade:
    case Precision.Year:
      iso8601String = yearString;
      break;

    case Precision.Month:
      iso8601String = `${yearString}-${padWithZeros(date.month)}`;
      break;

    case Precision.Week:
    case Precision.Day:
      iso8601String = `${yearString}-${padWithZeros(date.month)}-${padWithZeros(date.day)}`;
      break;

    case Precision.Hour:
      iso8601String = `${yearString}-${padWithZeros(date.month)}-${padWithZeros(date.day)}T${padWithZeros(
        date.hour
      )}:00`;
      break;

    case Precision.Minute:
      iso8601String = `${yearString}-${padWithZeros(date.month)}-${padWithZeros(date.day)}T${padWithZeros(
        date.hour
      )}:${padWithZeros(date.minute)}`;
      break;

    case Precision.Second:
    case Precision.Auto:
      iso8601String = `${yearString}-${padWithZeros(date.month)}-${padWithZeros(date.day)}T${padWithZeros(
        date.hour
      )}:${padWithZeros(date.minute)}:${padWithZeros(date.second)}`;
      break;
  }

  return iso8601String;
};

export const padWithZeros = (num, size = 2) => {
  let paddedString = num.toString();
  while (paddedString.length < (size || 2)) {
    paddedString = "0" + paddedString;
  }
  return paddedString;
};
